import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { FinancialEntityBranchFailure, FinancialEntityBranchRequest, FinancialEntityBranchSuccess } from './actions';
import { FinancialEntityBranch } from '@models/swagger';

export const featureKey = 'financialEntityBranch';

export interface State {
  data: FinancialEntityBranch | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(FinancialEntityBranchFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(FinancialEntityBranchRequest, state => ({ ...state, error: null, loading: true })),
    on(FinancialEntityBranchSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
